import { render, staticRenderFns } from "./TransactionMappingTable.vue?vue&type=template&id=449d81b0&scoped=true"
import script from "./TransactionMappingTable.vue?vue&type=script&lang=js"
export * from "./TransactionMappingTable.vue?vue&type=script&lang=js"
import style0 from "./TransactionMappingTable.vue?vue&type=style&index=0&id=449d81b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449d81b0",
  null
  
)

export default component.exports